import Home from '@src/main/ui/components/Home/Home';
import { type FC } from 'react';

const HomePage: FC = () => <Home />;

export default HomePage;
